import { useCallback } from "react";
import { Button } from "@mui/material";
import { dynamicNotification } from "src/utils/Notifications";
import __ from "src/utils/Translations";

import {
  IWaitingRoom,
  IWaitingRoomCondition,
} from "src/Pages/Company/Pending/PendingBenefits/types";
import { useMassAccept } from "src/Pages/Company/Pending/PendingBenefits/query";
import { useSelectedRows } from "src/Pages/Company/Pending/PendingBenefits/SelectedRowsProvider/hooks";

export const AcceptWaitingRoomCondition = ({
  waitingRoom,
  condition,
}: {
  waitingRoom: IWaitingRoom;
  condition: IWaitingRoomCondition;
}) => {
  const { isPending, mutate } = useMassAccept();

  const { resetSelection } = useSelectedRows();

  const handleWaitingRoomConditionAccept = useCallback(() => {
    mutate(
      {
        documents: [],
        waitingRooms: [
          {
            waitingRoomId: waitingRoom.id,
            conditionIds: [condition.id],
          },
        ],
      },
      {
        onSuccess: () => {
          dynamicNotification(__("Pomyślnie zaakceptowano wymaganie"));
        },
        onError: () => {
          dynamicNotification(
            __("Nie udało się zaakceptować wymaganie"),
            "error"
          );
        },
        onSettled: () => {
          resetSelection();
        },
      }
    );
  }, [condition.id, mutate, resetSelection, waitingRoom.id]);

  return (
    <Button
      size="small"
      variant="outlined"
      loading={isPending}
      onClick={handleWaitingRoomConditionAccept}
      sx={{ minWidth: "105px" }}
    >
      {__("Akceptuj")}
    </Button>
  );
};
